// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".steps[data-v-606ba4ee]> div{display:flex;flex-direction:column;justify-content:space-between}@media (min-width:769px){.steps[data-v-606ba4ee]> div{flex-direction:row}}.steps[data-v-606ba4ee]> div>div{width:100%;padding-bottom:1rem}@media (min-width:769px){.steps[data-v-606ba4ee]> div>div{width:30%}}.steps[data-v-606ba4ee]> div>div h3{font-size:1rem;color:#0a3592}", ""]);
// Exports
module.exports = exports;
